<template>
  <div id="app">
    <navigationBar></navigationBar>
    <router-view class="routerView" />
    <bottomBar ></bottomBar>
  </div>
</template>

<script>
import navigationBar from '@/components/NavigationBar/index.vue'
import bottomBar from "@/components/bottomBar/index.vue";
export default {
  name: 'App',
  components: {
    navigationBar,
    bottomBar
  }
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
#app {  
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  justify-content: space-between;
}
.routerView{
  flex: 1;
  width: 100%;
}
</style>

